import { SIDELOADED_BUSINESS } from "constants/actionTypes";

import { offlineCrudReducer } from "lib/reducers";
import { deserializeSideLoadedBusiness } from "lib/serializers/sideLoadedBusinesses";

const sideLoadedBusinesses = offlineCrudReducer(SIDELOADED_BUSINESS, {
  deserializer: deserializeSideLoadedBusiness,
});

export default sideLoadedBusinesses;
